import { useMediaQuery } from "react-responsive";
import { MOBILE_BREAKPOINT_MEDIA_QUERY } from "../helpers/constants";

export default function useMobile() {
  const isMobile = useMediaQuery({ query: MOBILE_BREAKPOINT_MEDIA_QUERY });

  return {
    isMobile,
  };
}
